import styled from 'styled-components';

const LoadingImg = styled.img`
    width:30%;
    border-radius:20px;
`;

export default LoadingImg;